import { usePostHog } from "posthog-js/react";
import { type ReactNode, useEffect } from "react";

import { useAuth } from "../../features/auth/AuthContext";
import { identifyUser, resetPostHogIdentity } from "./posthog-client";

interface PostHogUserIdentifierProps {
  children: ReactNode;
}

export const PostHogUserIdentifier = ({ children }: PostHogUserIdentifierProps) => {
  const posthog = usePostHog();
  const { user, tenantId, tenantName, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && user) {
      identifyUser(posthog, {
        userId: user.id,
        userProperties: {
          email: user.email,
          name: user.user_metadata?.name
        },
        tenantId: tenantId || undefined,
        tenantName: tenantName || undefined
      });
    } else if (!isLoading && !user) {
      resetPostHogIdentity(posthog);
    }
  }, [user, tenantId, tenantName, isLoading, posthog]);

  return <>{children}</>;
};
